var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowLoader)?_c('div',{staticClass:"zendesk-loader"},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader__container"},[_c('magic-ui-loader')],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }